import React, { useContext } from 'react';
import {
  Center,
  useRadio,
  useStyles,
} from '@chakra-ui/react';
import { radioButtonsContext } from '../RadioButtonGroup/RadioButtonGroup';

export const RadioButton = (props) => {
  const {
    id,
    value,
    children,
    ...contentProps
  } = props;
  const styles = useStyles();
  const { getRadioProps, ref, isInvalid } = useContext(radioButtonsContext);
  const radioProps = getRadioProps({ value });
  const {
    getInputProps,
    getLabelProps,
    getCheckboxProps,
  } = useRadio({ ...radioProps, isInvalid, id });
  const input = getInputProps();
  const label = getLabelProps();
  const checkbox = getCheckboxProps();

  return (
    <Center
      as="label"
      htmlFor={id}
      __css={styles.label}
      aria-invalid={isInvalid ? 'true' : ''}
      _invalid={{
        outlineOffset: '0',
        outline: '1px solid',
        outlineColor: 'red.500',
        _active: {
          outline: '2px solid',
        },
      }}
      {...label}
      {...contentProps}
      {...checkbox}
    >
      <input
        ref={ref}
        {...input}
        {...checkbox}
      />
      {children}
    </Center>
  );
};
